const useCustomEvent = (eventName) => {
    const triggerEvent = (data = null) => {
        window.dispatchEvent(
            new CustomEvent(eventName, {
                bubbles: false,
                detail: data,
            })
        );
    };

    return {
        triggerEvent,
    };
};

export default useCustomEvent;
